import React, { useEffect } from 'react';
import './App.css';
import { initGA, trackPageView } from './utils/analytics';

import Home from './components/Home/home'
import Nav from './components/Navigation/nav';
import About from './components/About/about';
import Certs from './components/Certifications/certs';
import Work from './components/Work/work';
import Projects from './components/Projects/projects';
import Contact from './components/Contact/contact';

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
    trackPageView(window.location.href, document.title);

    // Add structured data for SEO
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Lusaduma Mata",
      "jobTitle": "IBM Graduate Consultant & CVM Campaign Designer",
      "description": "IBM Graduate Consultant and CVM Campaign Designer at IBM South Africa, working on Telkom. AWS Certified, Microsoft AI-900, and Fortinet Certified. Skilled in HCL Unica, Oracle SQL, React, JavaScript, Python, Java, and cloud technologies.",
      "url": "https://mr-mata-portfolio.vercel.app/",
      "image": "https://mr-mata-portfolio.vercel.app/images/Graduation_picture-removebg-preview.png",
      "worksFor": {
        "@type": "Organization",
        "name": "IBM South Africa",
        "url": "https://www.ibm.com/za-en"
      },
      "alumniOf": {
        "@type": "CollegeOrUniversity",
        "name": "IIE Rosebank College"
      },
      "hasCredential": [
        {
          "@type": "EducationalOccupationalCredential",
          "name": "Diploma in Information Technology in Software Development",
          "educationalLevel": "Diploma",
          "credentialCategory": "degree"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "name": "AWS Certified Cloud Practitioner - Foundational",
          "credentialCategory": "certification",
          "recognizedBy": { "@type": "Organization", "name": "Amazon Web Services" }
        },
        {
          "@type": "EducationalOccupationalCredential",
          "name": "Microsoft Certified: Azure AI Fundamentals (AI-900)",
          "credentialCategory": "certification",
          "recognizedBy": { "@type": "Organization", "name": "Microsoft" }
        },
        {
          "@type": "EducationalOccupationalCredential",
          "name": "Fortinet Certified Associate - Cybersecurity",
          "credentialCategory": "certification",
          "recognizedBy": { "@type": "Organization", "name": "Fortinet" }
        },
        {
          "@type": "EducationalOccupationalCredential",
          "name": "Fortinet Certified Fundamentals - Cybersecurity",
          "credentialCategory": "certification",
          "recognizedBy": { "@type": "Organization", "name": "Fortinet" }
        }
      ],
      "knowsAbout": [
        "Customer Value Management (CVM)",
        "HCL Unica Campaign",
        "HCL Unica Interact",
        "Oracle SQL",
        "Campaign Design",
        "React",
        "JavaScript",
        "Python",
        "Java",
        "Node.js",
        "AWS",
        "Azure",
        "Cybersecurity",
        "Mobile Development",
        "Web Development",
        "Software Development"
      ],
      "nationality": "South African",
      "sameAs": [
        "https://github.com/Lusa-mata",
        "https://www.linkedin.com/in/lusaduma-ok-mata",
        "https://www.credly.com/users/lusaduma-mata"
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div>
      <Nav/>
      <Home/>
      <About/>
      <Certs/>
      <Work/>
      <Projects/>
      <Contact/>
    </div>
  );
}

export default App;
